export const ACTIVATION_USERDATA_API = "api/userdata/activation";
export const ACTIVATION_API = "api/activation";
export const RANK_TRACKER_API = "api/rankTracker";
export const ACTIVATION_HOME_API = `${ACTIVATION_API}/homepage`;

export const HOMEPAGE_TEXT = "common.home";
